/*
  PDP enhancements — runs only on /products/* (included from layout/theme.liquid
  inside {% if template.name == 'product' %}).

  Currently provides:
  - Quantity stepper: wraps the bare #quantity input in a .poter-qty pill
    with - / + buttons. Dispatches change + input events so theme JS
    (variant price, etc.) still fires when the stepper is used.

  Re-runs on shopify:section:load so variant switches that re-render the
  product form re-attach the stepper. dataset.poterQty guards against
  double-wrapping.
*/
(function () {
  function enhance(input) {
    if (!input || input.dataset.poterQty === '1') return;
    input.dataset.poterQty = '1';
    var wrap = input.closest('.f8pr-amount') || input.parentElement;
    if (!wrap) return;
    wrap.classList.add('poter-qty');
    // Theme's semanticInputAsync() at custom-async.js:1119 finds every
    // .input-amount, wraps its contents in <span class="semantic-amount">,
    // and overlays the input with <a class="incr/decr"> (text-indent
    // -3000em → number invisible). Defuse it:
    // 1. Strip .input-amount so it can't be re-selected.
    // 2. Set .semantic-input-initialized so even if .input-amount comes
    //    back, the theme JS skips us.
    // 3. Unwrap any .semantic-amount that already ran, and remove any
    //    .incr/.decr overlays it created.
    wrap.classList.remove('input-amount');
    wrap.classList.add('semantic-input-initialized');
    var sem = wrap.querySelector('.semantic-amount');
    if (sem) {
      while (sem.firstChild) sem.parentNode.insertBefore(sem.firstChild, sem);
      sem.parentNode.removeChild(sem);
    }
    var existingOverlays = wrap.querySelectorAll('.incr, .decr');
    Array.prototype.forEach.call(existingOverlays, function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    // Also tag the .link-btn row so CSS can guarantee inline layout next to
    // the CTA without depending on :has() selector support.
    var rowP = input.closest('p.link-btn');
    if (rowP) rowP.classList.add('poter-qty-row');

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'poter-qty-btn';
    minus.textContent = '−'; // minus sign
    minus.setAttribute('aria-label', 'Reducer antal');

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'poter-qty-btn';
    plus.textContent = '+';
    plus.setAttribute('aria-label', 'Forg antal');

    wrap.insertBefore(minus, input);
    wrap.appendChild(plus);

    function step(delta) {
      var min = parseInt(input.min || '1', 10);
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      var v = parseInt(input.value || '1', 10) + delta;
      if (isNaN(v)) v = min;
      if (v < min) v = min;
      if (v > max) v = max;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    minus.addEventListener('click', function () { step(-1); });
    plus.addEventListener('click', function () { step(1); });
  }

  // Move the Poter Service Squares section into the right info column,
  // immediately after the buy-button form (".overlay-buy_button"'s closest
  // <form>). The section renders OUTSIDE main-product because main-product
  // is locked (size limit). Mounting it inline here matches the client's
  // mockup where the 3 USP squares sit right under "Læg i kurv".
  function mountServiceSquares() {
    var squares = document.querySelector('.shopify-section--poter-service-squares .poter-service-squares');
    if (!squares || squares.dataset.poterMounted === '1') return;
    // Theme editor reloads the section on every block edit, which re-renders
    // a fresh .poter-service-squares element in its original (hidden) spot.
    // Clean up any PREVIOUSLY-mounted instance before mounting the new one,
    // otherwise each edit stacks another row in the right column.
    var prev = document.querySelectorAll('.poter-service-squares--mounted');
    Array.prototype.forEach.call(prev, function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    var cta = document.querySelector('.f8pr.f8pr-container .overlay-buy_button');
    if (!cta) return;
    var anchor = cta.closest('form') || cta.closest('p.link-btn') || cta.parentElement;
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(squares, anchor.nextSibling);
    squares.classList.add('poter-service-squares--mounted');
    squares.dataset.poterMounted = '1';
  }

  // Inject a quantity input if the theme's buy_button block has
  // show_amount_selection turned off. Otherwise the merchant has to flip a
  // theme-editor setting just to get our stepper, which we don't want.
  // The injected input lives inside the same <p class="link-btn"> as the
  // CTA so it posts to /cart/add as `quantity` like a normal form field.
  function ensureQuantityInput() {
    var existing = document.getElementById('quantity');
    if (existing) return existing;
    var cta = document.querySelector('.f8pr.f8pr-container .overlay-buy_button');
    if (!cta) return null;
    var p = cta.closest('p.link-btn') || cta.parentElement;
    if (!p) return null;
    var span = document.createElement('span');
    // Intentionally NOT including 'input-amount' — see comment in enhance()
    // about theme's semanticInputAsync hijacking that class.
    span.className = 'f8pr-amount inline semantic-input-initialized';
    var input = document.createElement('input');
    input.type = 'number';
    input.id = 'quantity';
    input.name = 'quantity';
    input.value = '1';
    input.min = '1';
    input.required = true;
    span.appendChild(input);
    p.insertBefore(span, cta);
    p.classList.add('poter-qty-row');
    return input;
  }

  // Move the Størrelsesguide link into its own row placed AFTER the
  // variant selection (sizes + colors) and just above the price — CSS
  // gives .poter-sizechart-row order 55 in the flex column (variants are
  // 20, price is 60). The original <p> the theme rendered it in is hidden.
  // True when the size-guide drawer actually has something to show — an image
  // (block setting or the per-product custom.storrelsesguide metafield), or any
  // title/text/page content. The heading element always renders even when the
  // title is blank, so we test for a real image or non-whitespace text.
  function sizeGuideHasContent() {
    var aside = document.getElementById('size-guide');
    if (!aside) return false;
    if (aside.querySelector('img')) return true;
    return aside.textContent.replace(/\s+/g, '').length > 0;
  }

  // Whether this product has a size guide is a per-PRODUCT fact (image
  // metafield / block settings) — it never changes between variants. Compute it
  // ONCE from the initial, stable DOM and reuse it. Re-checking on every variant
  // change was unreliable: the re-rendered form transiently duplicates/moves the
  // #size-guide drawer, so the check gave a false positive and the link came
  // back on products that have no guide. Caching kills that.
  var _hasSizeGuide = null;
  function mountSizechartRow() {
    var link = document.querySelector('.f8pr.f8pr-container a[data-panel="size-guide"]');
    if (!link || link.dataset.poterMoved === '1') return;
    if (_hasSizeGuide === null) _hasSizeGuide = sizeGuideHasContent();
    // If the guide is empty in admin (no image/metafield, no title/text/page),
    // don't show the link at all — it would otherwise open an empty drawer.
    // Not flagged poterMoved, so a later variant re-render re-hides the
    // freshly rendered link using the cached result.
    if (!_hasSizeGuide) {
      var emptyP = link.closest('p');
      if (emptyP) emptyP.style.setProperty('display', 'none', 'important');
      else link.style.setProperty('display', 'none', 'important');
      return;
    }
    var container = document.querySelector('.f8pr.f8pr-container');
    if (!container) return;
    var srcP = link.closest('p');
    var row = document.createElement('p');
    row.className = 'poter-sizechart-row';
    row.appendChild(link);
    container.appendChild(row);
    if (srcP && srcP !== row) srcP.style.setProperty('display', 'none', 'important');
    link.classList.add('poter-sizechart-inline');
    link.dataset.poterMoved = '1';
  }

  // Brand name above the product title, linking to Shopify's built-in
  // vendor listing (/collections/vendors?q=BRAND — works without creating
  // per-brand collections). Vendor comes from ShopifyAnalytics meta, which
  // the theme always emits on product pages. CSS gives .poter-pdp-brand
  // order 3 — above the title header (order 5).
  function mountBrandLink() {
    var container = document.querySelector('.f8pr.f8pr-container');
    if (!container || container.querySelector('.poter-pdp-brand')) return;
    var vendor = '';
    try { vendor = (window.ShopifyAnalytics.meta.product.vendor || '').trim(); } catch (e) {}
    if (!vendor) return;
    var a = document.createElement('a');
    a.className = 'poter-pdp-brand';
    a.href = '/collections/vendors?q=' + encodeURIComponent(vendor);
    a.textContent = vendor;
    container.appendChild(a);
  }

  // Buy-button label: theme renders the translation "Føj til kurv"; the
  // client wants the same wording as the cards — "Tilføj til kurv".
  // (Text swap here instead of editing locales so the change is scoped to
  // the PDP main button, not every add-to-cart string sitewide.)
  function relabelBuyButton() {
    var btn = document.querySelector('.f8pr.f8pr-container .overlay-buy_button');
    if (btn && btn.textContent.trim() !== 'Tilføj til kurv') {
      btn.textContent = 'Tilføj til kurv';
    }
  }

  function boot() {
    var input = ensureQuantityInput();
    if (input) enhance(input);
    mountServiceSquares();
    mountSizechartRow();
    mountBrandLink();
    relabelBuyButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  // A live variant change (color/size) re-renders the product form via AJAX
  // in custom-async.js (productVariantsAsync). That wipes our injected
  // #quantity stepper, and — unlike the theme editor — it does NOT fire
  // shopify:section:load, so boot() never re-ran and the stepper stayed gone
  // until a full reload. The theme dispatches "themeVariantUpdated" right after
  // it swaps in the new form HTML; re-run boot() there to re-inject the stepper
  // (and re-apply the buy-button relabel). All boot() steps are idempotent.
  window.addEventListener('themeVariantUpdated', boot);
})();
